var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.7917 11.5417L11.8542 10.4792L8.75 7.375V3H7.25V8L10.7917 11.5417V11.5417M8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.84722 0.625 4.875C1.04167 3.90278 1.61458 3.05556 2.34375 2.33333C3.07292 1.61111 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1528 0.208333 11.125 0.625C12.0972 1.04167 12.9444 1.61111 13.6667 2.33333C14.3889 3.05556 14.9583 3.90278 15.375 4.875C15.7917 5.84722 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3889 12.9271 13.6667 13.6562C12.9444 14.3854 12.0972 14.9583 11.125 15.375C10.1528 15.7917 9.11111 16 8 16V16M8 8V8V8V8V8V8V8V8V8V8M8 14.5C9.80556 14.5 11.3403 13.8646 12.6042 12.5938C13.8681 11.3229 14.5 9.79167 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.20833 1.5 4.67708 2.13194 3.40625 3.39583C2.13542 4.65972 1.5 6.19444 1.5 8C1.5 9.79167 2.13542 11.3229 3.40625 12.5938C4.67708 13.8646 6.20833 14.5 8 14.5V14.5",
    fill: "#1D4ED8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionClock);
export default __webpack_public_path__ + "static/media/section-clock.54e7f2db0c41375ef3e8a51efca8c0f9.svg";
export { ForwardRef as ReactComponent };